import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';

const TestimonialCard = ({ quote, author, role, avatarSrc }) => (
  <Flex sx={{ justifyContent: 'space-between', gap: '16px', width: '100%' }}>
    {avatarSrc && (
      <Box sx={{ position: 'relative', width: '64px', height: '64px', flexShrink: 0 }}>
        <Box
          as="img"
          src={avatarSrc}
          alt={author}
          sx={{
            objectFit: 'cover',
            width: '64px',
            height: '64px',
            borderRadius: '64px',
          }}
        />
      </Box>
    )}
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', flex: 1 }}>
      <Box
        sx={{
          borderRadius: '4px',
          bg: 'neutral.20',
          p: '16px',
          position: 'relative',
          ...((author || role) && {
            '&::before': {
              content: '""',
              position: 'absolute',
              left: '-10px',
              top: '22px',
              width: 0,
              height: 0,
              borderTop: '10px solid transparent',
              borderBottom: '10px solid transparent',
              borderRight: '10px solid',
              borderRightColor: 'neutral.20',
            },
          }),
        }}
      >
        <Text fontSize="16px" fontWeight="400" color="text.dark">
          &ldquo;{quote}&rdquo;
        </Text>
        {(author || role) && (
          <Box mt="16px">
            {author && <Text sx={{ color: 'text.dark', fontWeight: 600, fontSize: '14px' }}>{author}</Text>}
            {role && <Text sx={{ color: 'text.subtle', fontWeight: 400, fontSize: '14px' }}>{role}</Text>}
          </Box>
        )}
      </Box>
    </Box>
  </Flex>
);

TestimonialCard.propTypes = {
  quote: PropTypes.string.isRequired,
  author: PropTypes.string,
  role: PropTypes.string,
  avatarSrc: PropTypes.string,
};

TestimonialCard.defaultProps = {
  author: null,
  role: null,
  avatarSrc: null,
};

export default TestimonialCard;
